import React from "react";
import Image from "next/image";

interface IconProps {
  iconUrl: string;
  size?: number;
}

const Icon: React.FC<IconProps> = ({ iconUrl, size = 48 }) => (
  <Image src={iconUrl} alt="Icon" width={size} height={size} />
);

export default Icon;
